import {clearAll, portMonitorSelectedIdsSelector} from 'features/port/model/portMonitorSlice';
import {useMonitorSelection, IUseMonitorSelection} from 'entities/monitor';

export const usePortMonitorSelection = (): IUseMonitorSelection =>
    useMonitorSelection(portMonitorSelectedIdsSelector, clearAll);

export default usePortMonitorSelection;
